import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-no-date-switch',
  standalone: true,
  templateUrl: './no-date-switch.component.html',
  imports: [MatTooltip],
  styleUrl: './no-date-switch.component.scss'
})
export class NoDateSwitchComponent {
  @Input() onIcon = 'event_available';
  @Input() offIcon = 'event_busy';
  @Input() checked = true;
  @Output() checkedChange = new EventEmitter<boolean>();

  toggle(state?: boolean): void {
    this.checked = state === undefined ? !this.checked : state;
    this.checkedChange.emit(this.checked);
  }

  tooltipText() {
    return this.checked ? 'Filtering by using date picker' : 'Filtering by empty date';
  }
}
